import * as React from 'react';
import { getAppModule } from '_appModuleRegister';
export const SelectedAppModuleContext = React.createContext(null);
SelectedAppModuleContext.displayName = 'SelectedAppModuleContext';
export function useCurrentModule() {
    const context = React.useContext(SelectedAppModuleContext);
    if (!context) {
        return undefined;
    }
    return getAppModule(context);
}
